import { FaBan } from "react-icons/fa";

export function Bloqueado() {
  return <FaBan style={{ color: "#999999" }} />;
}
